import SeparatedList from 'components/shared/SeparatedList'
import DiscountedProduct from 'components/global/omnibus/DiscountedProducts/DiscountProduct'
import { GetCartItemPresenter } from 'store/api-slice/hooks'

interface DiscountedTicketsListProps {
    tickets: GetCartItemPresenter[]
}

const DiscountedTicketsList = ({ tickets }: DiscountedTicketsListProps) => (
    // TODO: leave for now - promo may return this year
    // const endDate = moment('2023-11-27T23:59:59')
    // const currentDate = moment()

    <SeparatedList
        gap={[12, 20]}
        borderWidth={2}
        direction="column"
        isFullWidth
    >
        {tickets.map(
            ({
                quantity,
                name,
                description,
                unitPrice,
                totalPrice,
                totalPriceWithoutDiscount,
                lowestPriceLast30Days,
            }) => (
                <DiscountedProduct
                    quantity={quantity || 0}
                    title={name || ''}
                    subtitle={description || ''}
                    valueBefore={lowestPriceLast30Days || 0}
                    valueAfter={totalPrice || 0}
                    totalPriceWithoutDiscount={totalPriceWithoutDiscount || 0}
                    unitPrice={unitPrice || 0}
                    key={name}
                    counterAlignment="center"
                    // TODO: leave for now - promo may return this year
                    // hasBackToSchoolDisclaimer={
                    //     (lowestPriceLast30Days || 0) <
                    //         0.85 * (unitPrice || 0) &&
                    //     currentDate.isBefore(endDate)
                    // }
                />
            )
        )}
    </SeparatedList>
)

export default DiscountedTicketsList
